import { myNewsletterPreferences } from './myNewsletterPreferences';

require('./myNewsletterPreferences.scss');

export const myNewsletterPreferencesComponent = {
  template: require('./myNewsletterPreferences.html'),
  controllerAs: 'ctrl',
  controller: myNewsletterPreferences,
};
